export const Title: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className = '' }) => (
  <div
    className={`font-black uppercase text-card-foreground dark:text-white mb-3 leading-tight text-3xl sm:text-[40px] ${className}`}
    style={{
      fontWeight: 900,
      fontStyle: 'normal',
      lineHeight: '110%',
      letterSpacing: '-2%',
      textTransform: 'uppercase',
    }}
  >
    {children}
  </div>
);
